import type { Address } from 'ngx-google-places-autocomplete/objects/address';
import { IAddress, ICoordinate } from '../services/location/location.service';
import { HttpErrorResponse } from '@angular/common/http';

type TGetPlaceFromGeometry = Address['geometry']['location'] &
  Partial<Pick<Address, 'address_components'>>;

function isIncludes(val1: string, val2: string) {
  return (
    val1.toLowerCase().includes(val2.toLowerCase()) ||
    val2.toLowerCase().includes(val1.toLowerCase())
    // ||
    // val1.toLowerCase().includes(val3.toLowerCase()) ||
    // val3.toLowerCase().includes(val1.toLowerCase())
  );
}

export function getPlaceFromGeometry({
  lat,
  lng,
  address_components,
  from
}: TGetPlaceFromGeometry & { from: string }) {
  console.log({ lat, lng, address_components, from }, 'getPlaceFromGeometry');
  this.locationService.getLocation({ lat, lng }).subscribe(
    async (res) => {
      if (this.countries) {
        const addresses: unknown[] = address_components;
        let addressParts: string[] = [];
        let location: Partial<IAddress> = {};

        addresses?.forEach((address: any, index: number) => {
          addressParts.push(address.long_name);

          this.formattedAddress = addressParts.join(', ');

          if (address.types && address.types?.length) {
            for (let [key, value] of address.types.entries()) {
              switch (address.types[key]) {
                case 'street_number':
                  this.addressProps.street_number = address.long_name;
                  break;

                case 'route':
                  this.addressProps.route = address.long_name;
                  break;

                case 'locality':
                  this.addressProps.locality = address.long_name;
                  location.city = address.long_name;
                  break;

                case 'sublocality_level_1':
                  this.addressProps.sublocality_level_1 = address.long_name;
                  location.state = address.long_name;
                  break;

                case 'sublocality_level_2':
                  this.addressProps.sublocality_level_2 = address.long_name;
                  location.state = address.long_name;
                  break;

                case 'country':
                  this.addressProps.country = address.long_name;
                  location.country = address.long_name;

                  break;
              }
            }
          }
        });

        // country
        const country = this.countries.find(
          (country) =>
            country?.name === res?.address?.country || country?.name === location?.country
        );

        setTimeout(() => {
          this.vin.get('country').setValue(String(country?.id));
        }, 500);

        // state
        const states = await this.getStates(country?.id);

        const state = states.find((state) => isIncludes(state?.name, res?.address?.state));

        console.log(res?.address?.state, 'res?.address?.state', state?.id, states);

        setTimeout(() => {
          this.vin.get('state').setValue(String(state?.id));
        }, 500);

        //city
        const cities = await this.getCities(state?.id);

        const city = cities.find((city) => isIncludes(city?.city_name, res?.address?.city));

        console.log(res?.address?.city, 'city getLocation', cities, city);

        setTimeout(() => {
          this.vin.get('city').setValue(String(city?.city_id));
        }, 1000);
      }
    },
    (error: HttpErrorResponse) => {}
  );
}
